import React from "react";
import { useHistory } from "react-router-dom";

import { Logo } from "./styled";

export default function HeaderLogo() {
  const history = useHistory();
  const navigate = (to) => history.push(`/${to}`);

  return <Logo onClick={() => navigate("")} />;
}
